<template>
  <div ref="selectBox" class="select-box">
    <p v-if="portOrg == 1" class="schName">{{ userInfo.orgName }}</p>
    <Select
      v-else
      v-model="edu"
      :clearable="clearable"
      style="width: 200px"
      placeholder="请选择教育局"
      :disabled="disabled"
      :transfer="true"
      :filterable="filterable"
      @on-change="handleOnChange"
    >
      <Option v-for="item in eduList" :key="item.orgId" :value="item.orgId">{{
        item.name
      }}</Option>
    </Select>
  </div>
</template>

<script>
import resourcesManagementApi from '@/request/courseCenter/resources';

import operationAdmin from '@/request/operationAdmin/index.js';
import orderCenterApi from '@/request/orderCenter/index.js';
import { mapState } from 'vuex';
export default {
  props: {
    eduId: {
      default: '0',
      type: String
    },
    orgId: {
      default: '0',
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    orgId: {
      handler(newVal, oldVal) {
        newVal != 0 && this.org != newVal && this.showEdu != 1 && this.getEduList(newVal);
        this.org = newVal;
      },
      immediate: true
    },
    eduId: {
      handler(newVal) {
        console.log('newVal', newVal);
        if (newVal != this.edu) {
          this.edu = newVal;
        }
      },
      immediate: true
    }
  },
  computed: { ...mapState(['userInfo']) },
  data() {
    return {
      eduList: [],
      num: 0,
      edu: '0',
      org: '0',
      portOrg: localStorage.getItem('portOrg')

    };
  },
  created() {
    this.getEduList();
  },
  methods: {
    // 获取机构列表
    async getEduList(orgId = '') {
      let res;
      if (this.portOrg == 3) {
        if (!orgId) {
          return null;
        }
        res = await operationAdmin.getOrgEdusNew({
          orgId: orgId,
          reviewState: 1
        });
        this.handleInitEduList(res);
      } else if (this.portOrg == 0) {
        res = await orderCenterApi.getWxOrgList({
          pageNum: 1,
          pageSize: 200,
          orgType: 2// 教育局
        });
      } else {
        if (!orgId) {
          return null;
        }
        res = await resourcesManagementApi.getRelEdu({
          orgId: orgId
        });
      }
      if (this.portOrg == 0) {
        if (res.status === 200 && res.message.list.length) {
          this.eduList = [...res.message.list];
        }
      } else {
        if (res.status === 200 && res.message.length) {
          this.eduList = [...res.message];
          this.edu = res.message[0]['orgId'];
          this.handleOnChange(this.edu);
        }
      }
    },
    handleInitEduList(res) {
      if (res.status === 200 && res.message.length) {
        res.message.forEach(item => {
          item.orgId = item.educationBureauId,
          item.name = item.educationBureauName;
        });
      }
    },
    handleOnChange(val) {
      // let eduName = val ? this.eduList[this.eduList.findIndex((item) => item.orgId == val)]['name'] : ''
      const key = val ? this.eduList.findIndex((item) => item.orgId == val) : -1;
      console.log(key, 'keykeykey');
      this.$emit('on-change', {
        eduName: key != -1 ? this.eduList[key]['name'] : '',
        eduId: val,
        areaName: key != -1 ? this.eduList[key]['areaName'] : '',
        areaCode: key != -1 ? this.eduList[key]['areaCode'] : ''
      });
    }
  }
};
</script>

<style  lang="scss" scoped >
.schName {
  position: relative;
  top: 1px;
}
</style>
